const LangEgiftPurchaseDetail = {
	"egiftPurchaseDetail._title": ["E-GIFT", "E-GIFT"],
	"egiftPurchaseDetail._subTitle": ["TRANSACTION DETAILS", "CHI TIẾT GIAO DỊCH"],
	"egiftPurchaseDetail._dateTime": ["DATE AND TIME", "NGÀY GIỜ"],
	"egiftPurchaseDetail._to": ["TO", "ĐẾN"],
	"egiftPurchaseDetail._recipientEmail": ["RECIPIENT EMAIL", "EMAIL NGƯỜI NHẬN"],
	"egiftPurchaseDetail._giftAmount": ["GIFT AMOUNT", "SỐ TIỀN"],
	"egiftPurchaseDetail._message": ["MESSAGE", "TIN NHẮN"],
	"egiftPurchaseDetail._paymentMethod": ["PAYMENT METHOD", "HÌNH THỨC THANH TOÁN"],
	"egiftPurchaseDetail._paymentMethod.Type._Credit": ["Credit", "Thẻ tín dụng"],
	"egiftPurchaseDetail._orderNumber": ["ORDER NUMBER", "MÃ MUA HÀNG"],
	"egiftPurchaseDetail._expires": ["EXPIRES", "HẾT HẠN"],

	"egiftPurchaseDetail._addToMyAccount": ["ADD TO MY ACCOUNT", "NGÀY NHẬN"],
	"egiftPurchaseDetail._from": ["FROM", "TỪ"],
	"egiftPurchaseDetail._senderEmail": ["SENDER EMAIL", "EMAIL NGƯỜI GỬI"],
	"egiftPurchaseDetail._cardNumber": ["CARD NUMBER", "SỐ THẺ"],
	"egiftPurchaseDetail._securityCode": ["SECURITY CODE", "SỐ BẢO MẬT"],
	"egiftPurchaseDetail.error.fraud": [
		"Something went wrong while attempting to send the eGift to your friend. Please review your information and try again.",
		"Hiện tại, hệ thống không thể xử lý yêu cầu gửi eGift của bạn. Vui lòng kiểm tra lại thông tin và thử lại.",
	],
	"cardPurchaseDetail.error.fraud": [
		"We’re unable to complete your request to top up your card balance at the moment. Please try again later.",
		"Rất tiếc, hiện tại hệ thống không thể xử lý yêu cầu nạp thêm tiền vào thẻ của bạn. Vui lòng thử lại sau.",
	],
}
export default LangEgiftPurchaseDetail



// WEBPACK FOOTER //
// ./src/resources/modules/LangEgiftPurchaseDetail.js